import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    OnDestroy,
    Output,
    Input,
    ViewChild,
    ViewEncapsulation,
    OnInit
} from '@angular/core';
import { ModalComponent } from '@app/shared/ng2-bs3-modal';

import { AlertService } from '@app/shared/alert';
import { Utils } from '@app/shared/utils';
import { Event, TimelineComponent } from '@app/appointments/timeline/timeline.component';
import { LoadingIndicatorService } from '@app/shared/loading-indicator';
import { from, Subscription, Subscriber } from 'rxjs';
import { RestService } from '@app/core/rest.service';
import { AppointmentsService } from '@app/appointments/appointments.service';

declare let jQuery: any;
import * as moment from 'moment';
import { SearchOpenings } from '@app/shared/models/search-openings';
import { SystemData } from '@app/shared/system';

@Component({
    selector: 'rtn-waitlist-from-appointment',
    templateUrl: './waitlist-from-appointment.component.html',
    styleUrls: ['./waitlist-from-appointment.component.scss'],
})
export class WaitlistFromAppointmentComponent implements OnInit, AfterViewInit, OnDestroy {
    
    searchPatientSubscriber: Subscription;
    getSavedOpeningSearchSubscriber: Subscription;
        
    isLock: any;
    currentDate: any = moment();
    msg: string = 'Your account has been locked.';    
    @ViewChild('Waitlist_from_appointment') modal: ModalComponent;    
    @ViewChild('waitlistFromAptinputStartDateSaveSettingSearch') waitlistFromAptinputStartDateSaveSettingSearch: ElementRef;
    @ViewChild('waitlistFromAptinputEndDateSaveSettingSearch') waitlistFromAptinputEndDateSaveSettingSearch: ElementRef;
    @ViewChild('waitlistFromAptclickShowStartDateSaveSettingSearch') waitlistFromAptclickShowStartDateSaveSettingSearch: ElementRef;
    @ViewChild('waitlistFromAptclickShowEndDateSaveSettingSearch') waitlistFromAptclickShowEndDateSaveSettingSearch: ElementRef;
    @Output() reload: EventEmitter<any> = new EventEmitter();
    @Output() CloseWaitlistEmitter: EventEmitter<any> = new EventEmitter();

    //eventEntry: Event;
    //dataDateBook: DataDateBook = new DataDateBook;
    errorResponse: SearchOpenings = new SearchOpenings();
    errorMessage: string;
    errorMessageBook: string;
    searchDisabled = true;
    patients: any = [];
    patient_id: number;
    uuid: any;
    patient_name: any;
    isFamily = false;
    //availableSlots: any = [];
    //selectedSlot = 0;
    public apptId: number;
    time: any;
    input_group: any = '.input-group';
    search_field: any = '#search-field-new-appointment';
    searchOpenings: SearchOpenings = new SearchOpenings();
    searchOpeningsDistance: any;
    loadIconVerifiedPhone = false;
    verifiedPhone = false;
    msgPartialAccess
        = 'Your account has not full access yet. Please update insurance or contact RTN admin to get full access account';
    msgPedingAccess = 'Your account has not been activated.';
    successSaveOpeningSearch = '';
    errorSaveOpeningSearch = '';
    saveSettingsSubscriber: Subscription;
    //messageResponseErrorSearchOpen: string = null;
    isSaved: boolean = false;
    error_invalid_date: any = '';
    error_invalid_time: any = '';
    msgRequire: any = 'This field is required';
    formatDate: any = 'YYYY-MM-DD';
    appointmentTypeList: any;
    
    //requireMessage: RequireMessage = new RequireMessage();

    providerOfficeLists:any=[];
    fetchProviderOfficeSubscriber:Subscription;
    fetchAppointmentTypeListSubscriber:Subscription;
    embededPage:String='';
    advancenoticedurations:any=[];
    editwlmobile: any = {};

    constructor(
        private Service: AppointmentsService,
        private _alertService: AlertService,
        private _utils: Utils,
        private _loadingIndicatorService: LoadingIndicatorService,
        public _systemData: SystemData,        
    ) {
        // TODO
        this.searchOpeningsDistance = this._systemData.searchOpeningsDistance;
    }
    ngOnInit(): void {
        this.searchOpenings.enable_email = 0;
        this.searchOpenings.enable_sms = 0;
    }
    showMessage(msg: any) {
        this._alertService.showDismissButton = false;
        this._alertService.dismissButtonLabel = 'No';
        this._alertService.showCloseButton = true;
        this._alertService.closeButtonLabel = 'OK';
        this._alertService.title = msg;
        this._alertService.message = '';
        this._alertService.emitter('open');
    }    
    openAlertMessage(msg: string = '', reload: boolean = false) {
        this._alertService.onClose = () => {
            // Nothing
            if (reload == true) {
                this.dismiss();
            }
        };
        this._alertService.dismissButtonLabel = 'No';
        this._alertService.closeButtonLabel = 'OK';
        this._alertService.showDismissButton = false;
        this._alertService.showCloseButton = true;
        this._alertService.title = msg;
        this._alertService.message = '';
        this._alertService.emitter('open');
    }
    validatePatient(message: any) {
        if (this.searchOpenings.patient == '') {
            this.errorResponse.patient = message;
            return false;
        } else {
            return true;
        }
    }
    validateZipCode(message: any) {
        if (this.searchOpenings.zip == '') {
            this.errorResponse.zip = message;
            return false;
        } else {
            return true;
        }
    }
    validateDateFrom(message: any) {
        if (this.searchOpenings.start_date == '') {
            this.errorResponse.start_date = message;
            return false;
        } else {
            return true;
        }
    }
    validateDateEnd(message: any) {
        if (this.searchOpenings.end_date == '') {
            this.errorResponse.end_date = message;
            return false;
        } else {
            return true;
        }
    }
    validateEmail(message: any) {
        if (this.searchOpenings.enable_email == 1 && this.searchOpenings.email == null) {
            this.errorResponse.email = message;
            return false;
        } else {
            return true;
        }
    }
    validatePhone(message: any) {
        this.searchOpenings.mobile = this._utils.implodePhoneMobile(this.searchOpenings.first, this.searchOpenings.middle, this.searchOpenings.last);
        if (this.searchOpenings.enable_sms == 1 && this.searchOpenings.mobile == '') {
            this.errorResponse.mobile = message;
            return false;
        } else {
            return true;
        }
    }

    validateDateFromLessDateTo(message: any) {
        const date1 = new Date(this.searchOpenings.start_date);
        const date2 = new Date(this.searchOpenings.end_date);
        if (date1 > date2) {
            this.error_invalid_date = message;
            return false;
        } else {
            return true;
        }
    }
    /*validateAdvanceNoticeDuration(message:any){
        if (this.searchOpenings.advance_notice_duration == '') {
            this.errorResponse.advance_notice_duration = message;
            return false;
        } else {
            return true;
        }
    }*/
    removeErrEmail() {
        this.errorResponse.email = '';
        // jQuery('#emailInput').removeClass('input-error');
    }
    removeErrPhone() {
        this.errorResponse.mobile = '';
        // jQuery('#emailInput').removeClass('input-error');
    }
    clearMsgError() {
        this.errorResponse.patient = '';
        this.errorResponse.zip = '';
        this.errorResponse.start_date = '';
        this.errorResponse.end_date = '';
        this.errorResponse.email = '';
        this.errorResponse.mobile = '';
        this.error_invalid_date = '';
        this.error_invalid_time = '';
    }
    validate() {
        //const validatePatient = this.validatePatient(this.msgRequire);
        const validateZipCode = this.validateZipCode(this.msgRequire);
        const validateDateFrom = this.validateDateFrom(this.msgRequire);
        const validateDateEnd = this.validateDateEnd(this.msgRequire);
        const validateEmail = this.validateEmail(this.msgRequire);
        const validatePhone = this.validatePhone(this.msgRequire);
        const validateDateFromLessDateTo = this.validateDateFromLessDateTo('Date from must be less or equal than date to');
        //const validateDuration = this.validateAdvanceNoticeDuration(this.msgRequire);
        //&& validateDuration

        if (validateZipCode && validateDateFrom && validateDateEnd && validateEmail && validatePhone && validateDateFromLessDateTo) {
            return true;
        }
        return false;
    }

    getDataToSave() {
        this.searchOpenings.start_time = jQuery('#startTime1').val();
        this.searchOpenings.end_time = jQuery('#endTime1').val();
    }
    processSaveSearch() {
        this.clearMsgError();
        if (this.validate()) {
            this.setDataToSaveSearch();
            this.handleSaveSearch();
        }
    }
    setDataToSaveSearch() {
        if (this._utils.isPartialActiveStatus()) {
            this.openAlertMessage(this.msgPartialAccess);
            return;
        }
        this.successSaveOpeningSearch = '';
        this.errorSaveOpeningSearch = '';
        if (this.saveSettingsSubscriber) {
            this.saveSettingsSubscriber.unsubscribe();
        }
        this.getDataToSave();
        if (this.searchOpenings.enable_email) {
            this.searchOpenings.enable_email = 1;
        } else {
            this.searchOpenings.enable_email = 0;
        }

        if (this.searchOpenings.enable_sms) {
            this.searchOpenings.enable_sms = 1;
        } else {
            this.searchOpenings.enable_sms = 0;
        }
        this.searchOpenings.mobile = this._utils.implodePhoneMobile(this.searchOpenings.first, this.searchOpenings.middle, this.searchOpenings.last);

        this.searchOpenings.start_time = (this.searchOpenings.start_time != undefined && this.searchOpenings.start_time != null && this.searchOpenings.start_time != '') ? this.searchOpenings.start_time : '00:00:00';
        this.searchOpenings.end_time = (this.searchOpenings.end_time != undefined && this.searchOpenings.end_time != null && this.searchOpenings.end_time != '') ? this.searchOpenings.end_time : '23:59:59';

        const startTime:any = this.searchOpenings.start_time.split(':');
        const endTime:any = this.searchOpenings.end_time.split(':');

        console.log(this.searchOpenings);

        const startDatetime:any = moment(this.searchOpenings.start_date).hour(startTime[0])
            .minute(startTime[1]).second(0).utc().format('YYYY-MM-DDTHH:mm:ssZZ');
        const endDatetime:any = moment(this.searchOpenings.end_date).hour(endTime[0]).minute(endTime[1])
            .second(0).utc().format('YYYY-MM-DDTHH:mm:ssZZ');

        this.searchOpenings.start_datetime = startDatetime;
        this.searchOpenings.end_datetime = endDatetime;
    }
    
    
    showMsgError(response:any){
        if (response.patient_user_id != null) {
            this.errorResponse.patient = 'This patient is invalid';
        }
        if (response.zip != null) {
            this.errorResponse.zip = response.zip;
        }
        if (response.email != null) {
            this.errorResponse.email = response.email;
        }
        if (response.end_time != null) {
            this.error_invalid_time = response.end_time;
        }
        if (response.mobile != null) {
            this.errorResponse.mobile = response.mobile;
        }
    }
    
    onChange(event: any) {
        switch (event) {
            case 'patient':
                this.errorResponse.patient = '';
                break;
            case 'zip':
                this.errorResponse.zip = '';
                break;
            case 'startTime1':
                this.errorResponse.start_time = '';
                this.error_invalid_time = '';
                //this.onChangeDateTime(event);
                break;
            case 'endTime1':
                this.errorResponse.end_time = '';
                this.error_invalid_time = '';
                //this.onChangeDateTime(event);
                break;
            case 'email':
                this.errorResponse.email = '';
                break;
            case 'mobile':
                this.errorResponse.mobile = '';
                break;
            case 'advance_notice_duration':
                this.errorResponse.advance_notice_duration = '';
                //this.onChangeDateTime(event);
                break;
        }
    }
    onChangeDateTime(fieldTime:any){
        let start_time  = jQuery('#startTime1').val();
        let end_time    = jQuery('#endTime1').val();

        if ((fieldTime == 'startTime1' && start_time != '') || (fieldTime == 'endTime1' && end_time != '')) {
            this.searchOpenings.advance_notice_duration = '';
        } else if (fieldTime == 'advance_notice_duration') {
            jQuery('#startTime1').val('');
            jQuery('#endTime1').val('');
        }
    }
    // ========== Class Method ========== //

    ngAfterViewInit() {
        const _self = this;
        jQuery(document).ready(function () {
            jQuery(_self.waitlistFromAptinputStartDateSaveSettingSearch.nativeElement).datepicker({
                dateFormat: 'MM dd, yy',
                numberOfMonths: jQuery(window).width() < 768 ? 1 : 2,
                minDate: 0,
                showButtonPanel: true,
                onSelect: () => {
                    _self.errorResponse.start_date = '';
                    _self.error_invalid_date = '';
                    _self.onChange('startDate1');
                    _self.searchOpenings.start_date = moment(jQuery(_self.waitlistFromAptinputStartDateSaveSettingSearch.nativeElement)
                        .datepicker('getDate')).format(_self.formatDate);
                }
            });
            jQuery(_self.waitlistFromAptinputEndDateSaveSettingSearch.nativeElement).datepicker({
                dateFormat: 'MM dd, yy',
                numberOfMonths: jQuery(window).width() < 768 ? 1 : 2,
                minDate: 0,
                showButtonPanel: true,
                onSelect: () => {
                    _self.errorResponse.end_date = '';
                    _self.error_invalid_date = '';
                    _self.onChange('endDate1');
                    _self.searchOpenings.end_date = moment(jQuery(_self.waitlistFromAptinputEndDateSaveSettingSearch.nativeElement)
                        .datepicker('getDate')).format(_self.formatDate);
                }
            });

            jQuery(_self.waitlistFromAptclickShowStartDateSaveSettingSearch.nativeElement).click(() => {
                jQuery(_self.waitlistFromAptinputStartDateSaveSettingSearch.nativeElement).datepicker('show');
            });

            jQuery(_self.waitlistFromAptclickShowEndDateSaveSettingSearch.nativeElement).click(() => {
                jQuery(_self.waitlistFromAptinputEndDateSaveSettingSearch.nativeElement).datepicker('show');
            });
        });
        jQuery(document).on('click', function (e: any) {
            if (jQuery(e.target).hasClass('result dropdown-menu')
                || jQuery(e.target).hasClass('error-message')) {
                // TODO: Close dropdown when click outside
            } else {
                jQuery(_self.search_field).closest(_self.input_group).removeClass('open');
            }
        });

    }

    ngOnDestroy() {
        //this.selectedSlot = 0;
        if (this.searchPatientSubscriber) {
            this.searchPatientSubscriber.unsubscribe();
        }
        if (this.getSavedOpeningSearchSubscriber) {
            this.getSavedOpeningSearchSubscriber.unsubscribe();
        }
        /*if (this.fetchAvailableSlotSubscriber) {
            this.fetchAvailableSlotSubscriber.unsubscribe();
        }
        if (this.bookAppointmentSubscriber) {
            this.bookAppointmentSubscriber.unsubscribe();
        }
        if (this.deleteSlotSubscriber) {
            this.deleteSlotSubscriber.unsubscribe();
        }*/

        if (this.fetchProviderOfficeSubscriber) {
            this.fetchProviderOfficeSubscriber.unsubscribe();
        }
        if (this.fetchAppointmentTypeListSubscriber) {
            this.fetchAppointmentTypeListSubscriber.unsubscribe();
        }
    }

    // ========== General Modal Method ========== //

    dismiss() {
        this.searchOpenings.enable_email = 0;
        this.searchOpenings.enable_sms = 0;
        this.searchOpenings.patient = this.patient_id = null;
        //this.requireMessage = new RequireMessage();
        jQuery(this.search_field).parent().removeClass('open');
        this.clearData();
        this.clearMsgError();
        this.close();
        this.CloseWaitlistEmitter.emit(this.embededPage);
    }
    clearData() {
        this.searchOpenings = new SearchOpenings();
        this.errorResponse = new SearchOpenings();
        jQuery(this.waitlistFromAptinputStartDateSaveSettingSearch.nativeElement).datepicker('setDate', null);
        jQuery(this.waitlistFromAptinputEndDateSaveSettingSearch.nativeElement).datepicker('setDate', null);
        jQuery('#startTime1').val('');
        jQuery('#endTime1').val('');
        this.successSaveOpeningSearch = '';
        this.errorSaveOpeningSearch = '';
        this.loadIconVerifiedPhone = false;
        this.searchDisabled = true;
    }
    clearDataOncesaved() {
        this.searchOpenings = new SearchOpenings();
        this.errorResponse = new SearchOpenings();
        jQuery(this.waitlistFromAptinputStartDateSaveSettingSearch.nativeElement).datepicker('setDate', null);
        jQuery(this.waitlistFromAptinputEndDateSaveSettingSearch.nativeElement).datepicker('setDate', null);
        jQuery('#startTime1').val('');
        jQuery('#endTime1').val('');
        //this.successSaveOpeningSearch = '';
        //this.errorSaveOpeningSearch = '';
        this.loadIconVerifiedPhone = false;
        this.searchDisabled = true;
    }    
    open(id:any, curpage:any='') {
        this.apptId = id;
        this.embededPage = curpage;
        const self = this;        
        this.errorMessage = null;
        this.errorMessageBook = null;
        if (this.getSavedOpeningSearchSubscriber) {
            this.getSavedOpeningSearchSubscriber.unsubscribe();
        }        
        this.clearMsgError();
        this.fetchSavedInfo();
        
    }   
    close() {        
        this.modal.close();
    }
    
    fetchSavedInfo(){
        this._loadingIndicatorService.start();
        this.getSavedOpeningSearchSubscriber = this.Service.fetchWaitlistinfosInBooking(this.apptId).subscribe((success: any) => {
            this._loadingIndicatorService.stop();


            if (success.error_code === 'RC000') {
                this.searchOpenings = success.data;
                this.searchOpenings.start_date_display = moment(success.data.start_datetime).format('MMMM D, YYYY');
                this.searchOpenings.end_date_display = moment(success.data.end_datetime).format('MMMM D, YYYY');

                this.searchOpenings.start_date = moment(success.data.start_datetime).format('YYYY-MM-DD');
                this.searchOpenings.end_date = moment(success.data.end_datetime).format('YYYY-MM-DD');
                
                this.advancenoticedurations = success.data.advancenoticedurations;
                //this.editwlmobile = this._utils.explodePhoneMobile(this.searchOpenings);
                //console.log(this.advancenoticedurations);

                if (this.searchOpenings.mobile !== null) {

                    const num = this.searchOpenings.mobile.replace(/[^0-9]/g, '');
                    const firstMobileNumber = num.substr(0, 3);
                    const secondMobileNumber = num.substr(3, 3);
                    const thirdMobileNumber = num.substr(6, 4);
                    this.searchOpenings.first = '(' + firstMobileNumber + ')';
                    this.searchOpenings.middle = secondMobileNumber;
                    this.searchOpenings.last = thirdMobileNumber;
                }

            } else {
                this.errorSaveOpeningSearch = success.error_messages;
            } 
            this.modal.open();
        },(error: any) => {
                this._loadingIndicatorService.stop();
                const response = error.error;
                
                if (response.error_code === 'RC091') {
                    this.errorSaveOpeningSearch = response.error_messages;
                } else if (response.error_code === 'RC020') {
                    this.showMsgError(response.error_fields);
                } else if (response.error_code === 'RC101' || response.error_code === 'RC089' || response.error_code === 'RC135' || response.error_code === 'RC142') {
                    this.errorSaveOpeningSearch = response.error_messages;
                } 
            }
        );
    }
    handleSaveSearch() { 
        this._loadingIndicatorService.start();
        this.saveSettingsSubscriber = this.Service.saveWaitlistFromBooking(this.searchOpenings, this.apptId).subscribe(
            (success: any) => {
                this.isSaved = true;
                this._loadingIndicatorService.stop();
                const res = success;
                if (res.error_code === 'RC000') {
                    //this.successSaveOpeningSearch = res.error_messages;   
                    
                    this.clearDataOncesaved();

                    let that = this;
                    this._alertService.onClose = () => {
                        that.dismiss();
                        //that.close();
                    };
                    this._alertService.showDismissButton = false;
                    this._alertService.dismissButtonLabel = 'No';
                    this._alertService.showCloseButton = true;
                    this._alertService.closeButtonLabel = 'OK';
                    this._alertService.title = res.error_messages;
                    this._alertService.message = '';
                    this._alertService.emitter('open');
                }
            }, (error: any) => {
                this._loadingIndicatorService.stop();
                const response = error.error;
                this.loadIconVerifiedPhone = false;
                if (response.error_code === 'RC091') {
                    this.errorSaveOpeningSearch = response.error_messages;
                } else if (response.error_code === 'RC020') {
                    this.showMsgError(response.error_fields);
                } else if (response.error_code === 'RC101' || response.error_code === 'RC089' || response.error_code === 'RC135' || response.error_code === 'RC142') {
                    this.errorSaveOpeningSearch = response.error_messages;
                }             
            });        
    }
}